import { addDays, addMonths, addWeeks, endOfISOWeek, endOfMonth, startOfISOWeek, startOfMonth, } from 'date-fns';
export const getDefaultRanges = (t, onlyPast) => {
    const date = new Date();
    return [
        {
            label: t('common:dates.today'),
            startDate: date,
            endDate: date,
        },
        {
            label: t('common:dates.yesterday'),
            startDate: addDays(date, -1),
            endDate: addDays(date, -1),
        },
        ...(!onlyPast
            ? [
                {
                    label: t('common:dates.this_week'),
                    startDate: startOfISOWeek(date),
                    endDate: endOfISOWeek(date),
                },
            ]
            : []),
        {
            label: t('common:dates.last_week'),
            startDate: startOfISOWeek(addWeeks(date, -1)),
            endDate: endOfISOWeek(addWeeks(date, -1)),
        },
        {
            label: t('common:dates.last_seven_days'),
            startDate: addDays(date, -6),
            endDate: date,
        },
        ...(!onlyPast
            ? [
                {
                    label: t('common:dates.this_month'),
                    startDate: startOfMonth(date),
                    endDate: endOfMonth(date),
                },
            ]
            : []),
        {
            label: t('common:dates.last_month'),
            startDate: startOfMonth(addMonths(date, -1)),
            endDate: endOfMonth(addMonths(date, -1)),
        },
    ];
};
/** Example: 03.02.2000 - 1.9.2001 */
const GE_DATE_RANGE_REGEX = /(^0[1-9]|[12][0-9]|3[01]).(0[1-9]|1[0-2]).(\d{4}) - (0[1-9]|[12][0-9]|3[01]).(0[1-9]|1[0-2]).(\d{4}$)/;
/** Example: 2000-02-03 - 2001-09-01 */
const API_DATE_RANGE_REGEX = /^(\d{4})-([01]\d)-([0-3]\d) - (\d{4})-([01]\d)-([0-3]\d)$/;
/**
 * "03.02.2000 - 10.12.2001" -> "2000-02-03 - 2000-12-10"
 */
export const geDateRangeToApiDateRange = (geDateRange) => {
    for (let part; (part = GE_DATE_RANGE_REGEX.exec(geDateRange));) {
        const [, dd1, mm1, yyyy1, dd2, mm2, yyyy2] = part;
        return `${yyyy1}-${mm1}-${dd1} - ${yyyy2}-${mm2}-${dd2}`;
    }
    return null;
};
export const isValidGeDateRange = (textRange) => textRange ? GE_DATE_RANGE_REGEX.test(textRange) : false;
/**
 * "2000-02-03 - 2000-12-10" -> "03.02.2000 - 10.12.2001"
 */
export const apiDateRangeToGeDateRange = (apiDateRange) => {
    for (let part; (part = API_DATE_RANGE_REGEX.exec(apiDateRange));) {
        const [, yyyy1, mm1, dd1, yyyy2, mm2, dd2] = part;
        return `${dd1}-${mm1}-${yyyy1} - ${dd2}-${mm2}-${yyyy2}`;
    }
    return null;
};
/**
 * "03.02.2000 - 10.12.2001" -> {
 *   startDate: Date(),
 *   endDate: Date(),
 * }
 */
export const geDateRangeToMuiPickerDateRange = (geDateRange) => {
    for (let part; (part = GE_DATE_RANGE_REGEX.exec(geDateRange));) {
        const [, dd1, mm1, yyyy1, dd2, mm2, yyyy2] = part;
        return {
            startDate: new Date(Number.parseInt(yyyy1), Number.parseInt(mm1) - 1, Number.parseInt(dd1)),
            endDate: new Date(Number.parseInt(yyyy2), Number.parseInt(mm2) - 1, Number.parseInt(dd2)),
        };
    }
    return undefined;
};
/** TODO: add tests when refactoring
 * {
 *   startDate: Date(),
 *   endDate: Date(),
 * }
 * ->
 * "03.02.2000 - 10.12.2001"
 */
export const muiPickerDateRangeToGeDateRange = (dateRange) => {
    if (!dateRange.startDate || !dateRange.endDate) {
        return undefined;
    }
    const { startDate: s, endDate: e } = dateRange;
    //We use padStart here to make sure the date is formatted with a leading zero if the digits are below 2
    return `${String(s.getDate()).padStart(2, '0')}.${String(s.getMonth() + 1).padStart(2, '0')}.${s.getFullYear()} - ${String(e.getDate()).padStart(2, '0')}.${String(e.getMonth() + 1).padStart(2, '0')}.${e.getFullYear()}`;
};
